// Вкладки, экран которых ещё заглушка «Скоро» (W2–W3): по файлу-метке на вкладку в ./tabs/<ключ>.ts. Такая вкладка
// открывается, как в W1, поверх той, где были: без шапки, с кнопкой «Назад» и системной BackButton. Задача экрана
// вкладки удаляет свою метку — и вкладка становится обычной (шапка, переключение без записи в истории); общие файлы
// оболочки при этом не меняются.
const markers = import.meta.glob('./tabs/*.ts', { eager: true });

export const SOON_TABS: ReadonlySet<string> = new Set(Object.keys(markers).map((path) => /([^/]+)\.ts$/.exec(path)![1]!));
